import charts from '../charts.js';

export default function({ id, data, config, dates, settings = {} }) {
	settings = {
		data,
		legend: false,
		skipChartReady: true,

		scrollbar: {
			series: {
				valueYField: 'chart_close',
			},
		},

		... settings,
	};

	const chart = charts.draw(id, settings, dates);

	chart.historicalSeries = chart.addSeries(
		chart.lineSeries({
			name: 'historical',
			valueYField: 'close',
			layer: 5,
			tooltip: {
				labelFunction({ date_formatted, weeksAgo, symbol, close }) {
					if (+weeksAgo === 0) {
						if($('#external-tooltip').length===0) {
							return `${symbol} closed at [bold]$${close}[/] at the end of the last trading day (${date_formatted}).`;
						} else {
							$('#external-tooltip .line-series').html('<b>Historical Data:</b><br/>' + `${symbol} closed at <b>$${close}</b> at the end of the last trading day (${date_formatted}).`);
							return null;
						}
					}

					if($('#external-tooltip').length===0) {
						return `Week ending ${date_formatted} (${weeksAgo} weeks ago)\n${symbol} closed at [bold]$${close}.[/]`;
					} else {
						$('#external-tooltip .line-series').html('<b>Historical Data:</b><br/>' + `Week ending ${date_formatted} (${weeksAgo} weeks ago) ${symbol} closed at <b>$${close}.</b>`);
						return null;
					}
				},
			},
		})
	);

	chart.percentAxis = chart.addYAxis(chart.panel, {
		renderer: {
			opposite: true,
			minGridDistance: 20,
		},
		numberFormat: "#'%'",
		strictMinMax: true,
		strictMinMaxSelection: true,
		visible: false,
		grid: {
			opacity: 0,
		},
	});

	chart.seasonalitySeries = chart.addSeries(
		chart.lineSeries(
			{
				name: 'future',
				valueYField: 'projected_close',
				layer: 5,
				strokeDasharray: charts.values.strokeDash,
				tooltip: {
					labelFunction({ date, symbol, gain_loss, projected_close, probability, week, base_close, best_period, weeksAgo }) {
						if (!projected_close || isNaN(gain_loss) || weeksAgo === 0) {
							return null;
						}

						const text = [];

						if($('#external-tooltip').length===0) {
							text.push(`${symbol} projected to [bold]${gain_loss > 0 ? 'rise' : 'fall'} by ${Math.abs(gain_loss).toFixed(2)}%[/] and close at \n[bold]\$${projected_close} [/]over the next ${week} weeks based on the most recent trading day's closing price of \$${base_close}.  The historical accuracy of this stock rising is [bold]${probability}%.[/]`);
						} else {
							text.push(`${symbol} projected to <b>${gain_loss > 0 ? 'rise' : 'fall'} by ${Math.abs(gain_loss).toFixed(2)}%</b> and close at <b>\$${projected_close} </b>over the next ${week} weeks based on the most recent trading day's closing price of \$${base_close}.  The historical accuracy of this stock rising is <b>${probability}%.</b>`);
						}

						if (best_period) {
							if($('#external-tooltip').length===0) {
								text.push(`[${charts.colours.green.toCSSHex()}; bold]Best Period: [${charts.colours.green.toCSSHex()}]${symbol} has risen [${charts.colours.green.toCSSHex()}]by an [${charts.colours.green.toCSSHex()}]average of \n[${charts.colours.green.toCSSHex()}; bold]${best_period.average}% [${charts.colours.green.toCSSHex()}]during [${charts.colours.green.toCSSHex()}]this [${charts.colours.green.toCSSHex()}]${best_period.weeks}-week period [${charts.colours.green.toCSSHex()}]with a [${charts.colours.green.toCSSHex()}]track \n[${charts.colours.green.toCSSHex()}]record of [${charts.colours.green.toCSSHex()}; bold]${best_period.track_record}%.[/]`);
							} else {
								text.push(`<span style="color:${charts.colours.green.toCSSHex()}"> <br/><b>Best Period:</b><br/>${symbol} has risen by an average of <b>${best_period.average}%</b> during this ${best_period.weeks}-week period with a track record of <b>${best_period.track_record}%.</b></span>`);
							}
						}

						if($('#external-tooltip').length===0) {
							return text.join("\n\n");
						} else {
							$('#external-tooltip .line-series').html('<b>Seasonality Data:</b><br/>' + text.join('<br/>'));
							return null;
						}
					}
				},
			},
		)
	);

	chart.addGuide(config.lastData.timestamp, chart.xAxis);

	chart.earningsSeries = chart.addEarnings();

	if($('#external-tooltip').length!==0) {
		chart.earningsSeries.get('tooltip').label.adapters.add('text', (text, target) => {
			const data = target?._dataItem?.dataContext;

			if (!data || !data.earnings_text) {
				$('#external-tooltip .dot-series').html('');
				return null;
			}

			$('#external-tooltip .dot-series').html('<br/><b>Earnings Data:</b><br/>' + data.earnings_text);
			return null;
		});

		chart.earningsSeries.get('tooltip').adapters.add('visible', () => false);
		chart.seasonalitySeries.get('tooltip').adapters.add('visible', () => false);
		chart.historicalSeries.get('tooltip').adapters.add('visible', () => false);
	}

	return chart;
};
